export default __webpack_public_path__ + "static/media/Step5.9136fd7c.svg";